let runtimeContextPromise = null;

async function loadRuntime() {
  if (!runtimeContextPromise) {
    runtimeContextPromise = (async () => {
      const publicBaseUrl = process.env.PUBLIC_URL || "";
      const runtimeRootUrl = new URL(
        `${publicBaseUrl.replace(/\/$/, "")}/pdf-into-svg-runtime/`,
        window.location.origin
      );
      const frameworkRootUrl = new URL("./_framework/", runtimeRootUrl);
      const dotnetModuleUrl = new URL("./dotnet.js", frameworkRootUrl);
      const bootConfigUrl = new URL("./blazor.boot.json", frameworkRootUrl);

      const dotnetModule = await import(
        /* webpackIgnore: true */ dotnetModuleUrl.href
      );
      const createRuntime = dotnetModule.createDotnetRuntime ?? dotnetModule.default;

      if (typeof createRuntime !== "function") {
        throw new Error("Failed to load PDF-to-SVG runtime entry point.");
      }

      const runtime = await createRuntime({
        configSrc: bootConfigUrl.href,
      });
      const assemblyExports = await runtime.getAssemblyExports("PdfToSvgWasm.dll");
      const namespaceExports = assemblyExports?.PdfToSvgWasm?.PdfToSvgExports;

      if (!namespaceExports || typeof namespaceExports.ConvertPdfToSvg !== "function") {
        throw new Error("PDF-to-SVG runtime exports are unavailable.");
      }

      return {
        convert: namespaceExports.ConvertPdfToSvg,
        runtime,
      };
    })();
  }

  return runtimeContextPromise;
}

function toUint8Array(input) {
  if (input instanceof Uint8Array) {
    return input;
  }

  if (ArrayBuffer.isView(input)) {
    return new Uint8Array(
      input.buffer.slice(input.byteOffset, input.byteOffset + input.byteLength)
    );
  }

  if (input instanceof ArrayBuffer) {
    return new Uint8Array(input);
  }

  throw new TypeError("Unsupported PDF input type for SVG conversion.");
}

export async function initializePdfToSvgRuntime() {
  await loadRuntime();
}

export async function convertPdfBufferToSvgPages(input) {
  const data = toUint8Array(input);
  const { convert } = await loadRuntime();
  const pages = convert(data, null);

  return Array.isArray(pages) ? pages : [];
}
